import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import EventsScreen from "./pages/EventsScreen";
import ProductFeed from "./pages/ProductFeed";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import OrderSuccess from "./pages/OrderSuccess";
import DeliveryPage from "./pages/legal/DeliveryPage";
import ReturnsPage from "./pages/legal/ReturnsPage";
import OfferPage from "./pages/legal/OfferPage";
import PrivacyPage from "./pages/legal/PrivacyPage";
import { AdminAuthProvider } from "./context/AdminAuthContext";
import { CartProvider } from "./context/CartContext";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminEvents from "./pages/admin/AdminEvents";
import AdminEventForm from "./pages/admin/AdminEventForm";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminProductForm from "./pages/admin/AdminProductForm";
import AdminEventPreview from "./pages/admin/AdminEventPreview";
import AdminAnalytics from "./pages/admin/AdminAnalytics";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminDelivery from "./pages/admin/AdminDelivery";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CartProvider>
          <Routes>
            {/* Customer-facing routes */}
            <Route path="/" element={<EventsScreen />} />
            <Route path="/event/:eventId" element={<ProductFeed />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/order/:orderNumber" element={<OrderSuccess />} />
            <Route path="/delivery" element={<DeliveryPage />} />
            <Route path="/returns" element={<ReturnsPage />} />
            <Route path="/offer" element={<OfferPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />

            {/* Admin routes */}
            <Route path="/admin/login" element={
              <AdminAuthProvider>
                <AdminLogin />
              </AdminAuthProvider>
            } />
            <Route path="/admin" element={
              <AdminAuthProvider>
                <AdminLayout />
              </AdminAuthProvider>
            }>
              <Route index element={<AdminDashboard />} />
              <Route path="events" element={<AdminEvents />} />
              <Route path="events/new" element={<AdminEventForm />} />
              <Route path="events/:eventId/edit" element={<AdminEventForm />} />
              <Route path="events/:eventId/products" element={<AdminProducts />} />
              <Route path="events/:eventId/products/new" element={<AdminProductForm />} />
              <Route path="events/:eventId/products/:productId/edit" element={<AdminProductForm />} />
              <Route path="events/:eventId/preview" element={<AdminEventPreview />} />
              <Route path="orders" element={<AdminOrders />} />
              <Route path="delivery" element={<AdminDelivery />} />
              <Route path="analytics" element={<AdminAnalytics />} />
            </Route>
          </Routes>
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
